import { useEffect, useState } from "react";
import Lenis from "lenis";
import { Toaster } from "sonner";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import Marquee from "./components/Marquee";
import Manifesto from "./components/Manifesto";
import Pricing from "./components/Pricing";
import Calculator from "./components/Calculator";
import Conditions from "./components/Conditions";
import Lavori from "./components/Lavori";
import InstagramBand from "./components/InstagramBand";
import Showroom from "./components/Showroom";
import SopralluogoForm from "./components/SopralluogoForm";
import Footer from "./components/Footer";
import CookieBanner from "./components/CookieBanner";
import PrivacyOverlay from "./components/PrivacyOverlay";

function App() {
  const [estimate, setEstimate] = useState(null);

  useEffect(() => {
    const lenis = new Lenis({ duration: 1.2, smoothWheel: true });
    window.__lenis = lenis;
    let raf;
    const loop = (t) => {
      lenis.raf(t);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <div className="min-h-screen bg-cream" data-testid="app-root">
      <Navbar />
      <main>
        <Hero />
        <Marquee />
        <Manifesto />
        <Pricing />
        <Calculator onEstimate={setEstimate} />
        <Conditions />
        <Lavori />
        <Showroom />
        <SopralluogoForm prefill={estimate} />
        <InstagramBand />
      </main>
      <Footer />
      <CookieBanner />
      <PrivacyOverlay />
      <Toaster position="bottom-center" richColors />
    </div>
  );
}

export default App;
